"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 股票质押首页
 */
var searchnewsbox_1 = __importDefault(require("../../src/modules/searchnewsbox"));
var web_1 = __importDefault(require("../../config/web"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var base_1 = __importDefault(require("./base"));
var lodash_1 = __importDefault(require("lodash"));
//事件配置
loadevent();
//主表配置
loadtabledata();
// 搜素新闻的模块
searchnewsbox_1["default"]({
    dom: '.infolistBox',
    key: '股权质押',
    header: '股权质押',
    infolist_eventcode: 'sjpd_gqzylb_gqzyjd_wzqydjzh',
    more_eventcode: 'sjpd_gqzylb_gqzyjd_djgd'
});
//画图
loadchart();
function loadevent() {
    $(".chart_bar_legend :radio").on("change", function () {
        chart5($(this).data("type"), $("#filter_hy a.at").data("value"));
    });
    $("#filter_hy a").on("click", function () {
        var hy = $(this).data("value");
        $("#fbdatatype").text($(this).text().trim());
        if (hy == "银行")
            $(".fbtjlink").attr("href", "/gpzy/fbtj.html?hy=银行");
        else
            $(".fbtjlink").attr("href", "/gpzy/fbtj.html");
        chart5($("input[name='chart']:checked").data("type"), hy);
    });
    $('.tipsdiv .spread_more').click(function () {
        $(this).parent().toggleClass("active");
    });
}
function loadtabledata() {
    for (var _i = 0, _a = Object.entries(base_1["default"].gpzydataobj); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], typedata = _b[1];
        var opt = {
            scrolltop: false,
            dataurl: {
                hostname: "datacenter",
                url: "api/data/v1/get",
                params: {
                    reportName: typedata.type,
                    columns: "ALL",
                    quoteColumns: "",
                    source: "WEB",
                    client: "WEB",
                    //filter: typedata.filter,
                    sortColumns: typedata.st,
                    sortTypes: typedata.sr,
                    pageSize: typedata.showcount
                }
            },
            pagination: false,
            urlkeyvalues: base_1["default"].urlkeyvalues,
            totalpagesfield: 'result.pages',
            datafield: 'result.data',
            data: pagedata[key],
            theadmoreurl: "/gpzy/" + key + ".html?st={field}",
            columns: base_1["default"].columns[key],
            formatter: { num: 2 }
        };
        if (key == "fbtj") {
            opt.filteroptions = [
                {
                    name: 'filter',
                    fieldname: 'hy',
                    filterselector: "#filter_hy",
                    filtersoptionselector: "a",
                    selectedclass: "at",
                    values: function (value) {
                        return "(PFORG_TYPE=\"" + value + "\")";
                    }
                }
            ];
        }
        else {
            opt.dataurl.params.filter = typedata.filter;
        }
        $("#dataview_" + key).emdataview(opt);
    }
}
function loadchart() {
    //股权质押走势图
    chart1();
    //股权质押比例分布一览图
    chart2();
    //重要股东股权质押市场概况
    chart3();
    //主要质押方构成统计
    chart4();
    //质押方为证券公司的分布统计
    chart5("PLEDGE_DEAL_NUM", "证券");
}
function chart1() {
    new Promise(function (resolve, reject) {
        if (pagedata["chart1data"])
            resolve(pagedata["chart1data"]);
        else
            $.ajax({
                url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: "RPT_CSDC_STATISTICS",
                    columns: "ALL",
                    quoteColumns: "",
                    sortColumns: "TRADE_DATE",
                    sortTypes: -1,
                    pageSize: 50,
                    source: "WEB",
                    client: "WEB"
                },
                success: function (res) {
                    resolve(res);
                }
            });
    }).then(function (json) {
        var data = json && json.result && json.result.data;
        if (data && data.length > 0) {
            var listdata = data.reverse();
            var xaxisData = [];
            var seriesBlData = [];
            var seriesZsData = [];
            var chart = echarts.init(document.getElementById("chart1"));
            listdata.forEach(function (item, index) {
                xaxisData.push(fieldtools_1["default"].dateformat(item.TRADE_DATE, "YYYY/MM/DD"));
                seriesBlData.push(fieldtools_1["default"].fieldfmt(item.PM_RATIO, { zoom: -2 }));
                seriesZsData.push(fieldtools_1["default"].fieldfmt(item.CSI_300_INDEX));
            });
            var option = {
                color: ['#00a1ea', '#df3c1c'],
                legend: {
                    show: true,
                    top: 0,
                    left: 'right',
                    textStyle: {
                        color: "#6d6d6d"
                    }
                },
                grid: {
                    top: 30,
                    right: 15,
                    bottom: 10,
                    left: 15,
                    containLabel: true
                },
                tooltip: {
                    confine: true,
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#d6d6d6'
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#6d6d6d'
                        },
                        showMaxLabel: true
                    },
                    data: xaxisData
                },
                yAxis: [{
                        name: "单位：%",
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#6d6d6d'
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#6d6d6d'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#d6d6d6'
                            },
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#d6d6d6',
                                type: 'dotted'
                            },
                            show: false
                        },
                        scale: true
                    }, {
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#d6d6d6'
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#6d6d6d'
                            },
                            formatter: function (value, index) {
                                return fieldtools_1["default"].fieldfmt(value, { smart: true });
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#d6d6d6'
                            },
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#d6d6d6',
                                type: 'dotted'
                            }
                        },
                        scale: true
                    }],
                series: [
                    {
                        name: "A股质押总比例(左)",
                        type: 'line',
                        data: seriesBlData,
                        symbol: 'circle',
                        symbolSize: 2,
                        smooth: true,
                        showAllSymbol: false,
                        yAxisIndex: 0,
                        lineStyle: { width: 1.5 }
                    },
                    {
                        name: "沪深300指数(右)",
                        type: 'line',
                        data: seriesZsData,
                        symbol: 'circle',
                        symbolSize: 2,
                        smooth: true,
                        showAllSymbol: false,
                        yAxisIndex: 1,
                        lineStyle: { width: 1.5 }
                    }
                ]
            };
            chart.setOption(option);
        }
        else
            $("#chart1").html('<div class="nodata">暂无图表数据...</div>');
    });
}
function chart2() {
    new Promise(function (resolve, reject) {
        if (pagedata["chart2data"])
            resolve(pagedata["chart2data"]);
        else
            $.ajax({
                url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: "RPTA_APP_APLEDGERATIO",
                    columns: "ALL",
                    quoteColumns: "",
                    source: "WEB",
                    client: "WEB",
                    sortColumns: "RATIO_PARAMETER",
                    sortTypes: 1
                },
                success: function (res) {
                    resolve(res);
                }
            });
    }).then(function (json) {
        var list = json && json.result && json.result.data;
        var xdatas = [], ydatas = [];
        if (list && list.length > 0) {
            var end_date = fieldtools_1["default"].dateformat(list[0].END_DATE);
            $(".newdata_date").html(end_date);
            list.forEach(function (item) {
                xdatas.push(item.PLEDGE_RATIO_INTERVAL);
                ydatas.push(item.ORG_NUM);
            });
            var chart = echarts.init(document.getElementById("chart2"));
            var option = {
                title: {
                    text: "数据日期：" + end_date,
                    left: "center",
                    textStyle: { fontSize: 12, fontWeight: "normal" }
                },
                color: ['#00a1ea', '#df3c1c'],
                legend: {
                    show: false,
                },
                grid: {
                    top: 30,
                    right: 15,
                    bottom: 10,
                    left: 15,
                    containLabel: true
                },
                tooltip: {
                    confine: true,
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: '#d6d6d6'
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#6d6d6d'
                        },
                        showMaxLabel: true
                    },
                    data: xdatas
                },
                yAxis: [{
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#d6d6d6'
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#6d6d6d'
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#d6d6d6'
                            },
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#d6d6d6',
                                type: 'dotted'
                            },
                            show: true
                        },
                        scale: true
                    }],
                series: [
                    {
                        name: "公司数量",
                        type: 'bar',
                        barWidth: 30,
                        data: ydatas,
                        lineStyle: { width: 1.5 }
                    }
                ]
            };
            chart.setOption(option);
        }
        else
            $("#chart2").html('<div class="nodata">暂无图表数据...</div>');
    });
}
function chart3() {
    new Promise(function (resolve, reject) {
        if (pagedata["chart3data"])
            resolve(pagedata["chart3data"]);
        else
            $.ajax({
                url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: "RPTA_APP_WARNING",
                    columns: "ALL",
                    quoteColumns: "",
                    source: "WEB",
                    client: "WEB",
                    sortColumns: "WARNING_CODE"
                },
                success: function (res) {
                    resolve(res);
                }
            });
    }).then(function (json) {
        var list = json && json.result && json.result.data;
        if (list && list.length > 0) {
            var datas_1 = [];
            list.forEach(function (item) {
                var name = item.WARNING_CODE == 1 ? "未到预警线" : item.WARNING_CODE == 2 ? "已达预警线未达平仓" : "已达平仓";
                datas_1.push({ name: name, value: fieldtools_1["default"].fieldfmt(item.WARNING_RATIO_2, { num: 2 }), WARNING_NUM_2: item.WARNING_NUM_2 });
            });
            var chart = echarts.init(document.getElementById("chart3"));
            var option = {
                color: ['#29A3E3', '#E65B41', '#FFA83A'],
                legend: {
                    orient: 'vertical',
                    left: 'right',
                    top: 25,
                    align: 'left',
                    itemGap: 30,
                    formatter: function (name) {
                        var data = lodash_1["default"].find(datas_1, { name: name });
                        return name + "\n" + data.WARNING_NUM_2 + "\u7B14\uFF0C" + data.value + "%";
                    }
                },
                tooltip: {
                    confine: true,
                    trigger: 'item'
                },
                series: [
                    {
                        name: '重要股东股权质押市场概况',
                        type: 'pie',
                        label: {
                            show: false
                        },
                        radius: '90%',
                        center: ['35%', '50%'],
                        data: datas_1
                    }
                ]
            };
            chart.setOption(option);
        }
        else
            $("#cbox3").html('<div class="nodata">暂无图表数据...</div>');
    });
}
function chart4() {
    new Promise(function (resolve, reject) {
        if (pagedata["chart4data"])
            resolve(pagedata["chart4data"]);
        else
            $.ajax({
                url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: "RPTA_APP_PLEDGEORGTYPE",
                    columns: "PLEDGE_TYPE,PLEDGE_RATIO,PLEDGE_NUM",
                    quoteColumns: "",
                    source: "WEB",
                    client: "WEB"
                },
                success: function (res) {
                    resolve(res);
                }
            });
    }).then(function (json) {
        var list = json && json.result && json.result.data;
        if (list && list.length > 0) {
            var datas_2 = [];
            list.forEach(function (item) {
                datas_2.push({ name: item.PLEDGE_TYPE, value: fieldtools_1["default"].fieldfmt(item.PLEDGE_RATIO, { num: 2 }), PLEDGE_NUM: item.PLEDGE_NUM });
            });
            var chart = echarts.init(document.getElementById("chart4"));
            var option = {
                color: ['#29A3E3', '#FFA83A', '#7D61E6', '#E65B41', '#97b552', '#c14089'],
                legend: {
                    orient: 'vertical',
                    left: 'right',
                    top: 10,
                    align: 'left',
                    itemGap: 15,
                    formatter: function (name) {
                        var data = lodash_1["default"].find(datas_2, { name: name });
                        return name + "\n" + data.PLEDGE_NUM + "\u7B14\uFF0C" + data.value + "%";
                    }
                },
                tooltip: {
                    confine: true,
                    trigger: 'item'
                },
                series: [
                    {
                        name: '主要质押方构成统计',
                        type: 'pie',
                        label: {
                            show: false
                        },
                        radius: '90%',
                        center: ['35%', '50%'],
                        data: datas_2
                    }
                ]
            };
            chart.setOption(option);
        }
        else
            $("#chart4").html('<div class="nodata">暂无图表数据...</div>');
    });
}
function chart5(type, hy) {
    var obj = {
        PLEDGE_DEAL_NUM: { name: "质押方笔数" },
        PLEDGE_NUM: { name: "质押股份数量(股)", zoom: 4 },
        ORG_NUM: { name: "质押公司数量" }
    }[type];
    new Promise(function (resolve, reject) {
        if (pagedata["chart5data"])
            resolve(pagedata["chart5data"]);
        else
            $.ajax({
                url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
                type: "GET",
                dataType: "jsonp",
                data: {
                    reportName: "RPT_GDZY_ZYJG_SUM",
                    columns: "ALL",
                    quoteColumns: "",
                    source: "WEB",
                    client: "WEB",
                    pageSize: 100,
                    filter: "(PFORG_TYPE in (\"\u8BC1\u5238\",\"\u94F6\u884C\"))",
                },
                success: function (res) {
                    resolve(res);
                }
            });
    }).then(function (json) {
        pagedata["chart5data"] = json;
        var list = json && json.result && json.result.data;
        if (list && list.length > 0) {
            var listdata = list.filter(function (item) { return item.PFORG_TYPE == hy; }).sort(function (a, b) { return b[type] - a[type]; }).slice(0, 10);
            var xdata_1 = [];
            var ydata_1 = [];
            listdata.forEach(function (item, index) {
                xdata_1.push(item.SECURITY_NAME_ABBR);
                ydata_1.push(fieldtools_1["default"].fieldfmt(item[type], { omit: false, zoom: obj.zoom, num: 0 }));
            });
            var chart = echarts.init(document.getElementById("chart5"));
            var option = {
                color: ['#00a1ea', '#df3c1c'],
                legend: {
                    show: false,
                },
                grid: {
                    top: 15,
                    right: 15,
                    bottom: 10,
                    left: 15,
                    containLabel: true,
                },
                tooltip: {
                    confine: true,
                    trigger: 'axis',
                    formatter: function (data) {
                        var str = "";
                        var date = data[0].axisValue;
                        for (var i = 0; i < data.length; i++) {
                            str += data[i].marker + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { smart: true }) + '<br/>';
                        }
                        return date + '<br/>' + str;
                    }
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: '#d6d6d6'
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#6d6d6d'
                        },
                        showMaxLabel: true
                    },
                    data: xdata_1
                },
                yAxis: [{
                        type: 'value',
                        axisLine: {
                            lineStyle: {
                                color: '#d6d6d6'
                            },
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#6d6d6d'
                            },
                            formatter: function (value, index) {
                                return fieldtools_1["default"].fieldfmt(value, { smart: true });
                            }
                        },
                        axisTick: {
                            lineStyle: {
                                color: '#d6d6d6'
                            },
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#d6d6d6',
                                type: 'dotted'
                            },
                            show: true
                        },
                        scale: true
                    }],
                series: [
                    {
                        name: obj.name,
                        type: 'bar',
                        barWidth: 30,
                        data: ydata_1,
                        lineStyle: { width: 1.5 }
                    }
                ]
            };
            chart.setOption(option);
        }
        else
            $("#chart5").html('<div class="nodata">暂无图表数据...</div>');
    });
}
